import { Widget } from '@typeform/embed-react';
import React from 'react';

interface TypeformEmbedProps {
  readonly contract?: string | null;
  readonly type: string;
}

const TypeformEmbed: React.FC<TypeformEmbedProps> = ({ contract, type }) => {
  return <Widget hidden={{ ...(contract && { contract }) }} id={type} style={{ minHeight: '500px' }} />;
};

export { TypeformEmbed };
